import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';

const PostsListContainer = styled.div`
  .posts-list {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
`;

const PostItem = styled.div`
  padding: 1.5rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);

  h3 {
    color: #4a1a99;
    margin-bottom: 0.5rem;
  }

  .post-date {
    color: #666;
    font-style: italic;
    margin-bottom: 1rem;
  }
`;

const ContentPreview = styled.div`
  margin-bottom: 1rem;
  max-height: 200px;
  overflow: hidden;
  position: relative;

  &.expanded {
    max-height: none;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: linear-gradient(transparent, white);
    pointer-events: none;
  }

  &.expanded::after {
    display: none;
  }
`;

const ReadMoreButton = styled.button`
  display: inline-block;
  margin-top: 1rem;
  color: #6633cc;
  text-decoration: none;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  
  &:hover {
    text-decoration: underline;
  }
`;

const PostsList = () => {
  const [posts, setPosts] = useState([]);
  const [expandedPosts, setExpandedPosts] = useState({});
  const blogId = '1555415857002703612';
  const apiKey = 'AIzaSyBCuUWquNrat7XA0oeYfexifEjP5V7wRGE';

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(
          `https://www.googleapis.com/blogger/v3/blogs/${blogId}/posts?key=${apiKey}`
        );
        if (response.data && response.data.items) {
          setPosts(response.data.items);
        }
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    };
    fetchPosts();
  }, []);

  const toggleExpand = (postId) => {
    setExpandedPosts(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };

  return (
    <PostsListContainer>
      <div className="posts-list">
        <h2>Entradas recientes</h2>
        {posts.map((post) => (
          <PostItem key={post.id}>
            <h3>{post.title}</h3>
            <p className="post-date">
              {new Date(post.published).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
            <ContentPreview 
              className={expandedPosts[post.id] ? 'expanded' : ''}
            >
              <div dangerouslySetInnerHTML={{ __html: post.content }} />
            </ContentPreview>
            <ReadMoreButton 
              onClick={() => toggleExpand(post.id)}
            >
              {expandedPosts[post.id] ? 'Mostrar menos' : 'Leer más →'}
            </ReadMoreButton>
          </PostItem>
        ))}
      </div>
    </PostsListContainer>
  );
};

export default PostsList;
